import { render, staticRenderFns } from "./ErrorBodySection.vue?vue&type=template&id=3c99f13f&scoped=true"
import script from "./ErrorBodySection.vue?vue&type=script&lang=ts"
export * from "./ErrorBodySection.vue?vue&type=script&lang=ts"
import style0 from "./ErrorBodySection.vue?vue&type=style&index=0&id=3c99f13f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c99f13f",
  null
  
)

export default component.exports